<template>
  <header class="mk-header">
    <div class="container d-flex align-items-center flex-wrap" style="gap: 12px;">
      <router-link to="/marketplace" class="mk-brand">
        <img src="/assets/img/kgshia_logo.png" alt="KGSHIA" width="34" height="34" />
        <span>KGSHIA <strong>Marketplace</strong></span>
      </router-link>

      <nav class="ml-auto d-flex align-items-center flex-wrap" style="gap: 8px;">
        <router-link to="/marketplace/cart" class="mk-link">
          <i class="fe fe-shopping-cart mr-1"></i>Cart
          <span class="mk-count" v-if="cartCount">{{ cartCount }}</span>
        </router-link>
        <router-link v-if="signedIn" to="/pusher" class="mk-link">
          <i class="fe fe-grid mr-1"></i>My Portal
        </router-link>
        <router-link v-else to="/" class="mk-link">
          <i class="fe fe-log-in mr-1"></i>Sign in
        </router-link>
        <router-link v-if="!signedIn" to="/vendor/signup" class="mk-sell">
          <i class="fe fe-briefcase mr-1"></i>Sell on Claimify
        </router-link>
      </nav>
    </div>
  </header>
</template>

<script>
import cart from "./cart";

export default {
  name: "MarketplaceHeader",
  data() {
    return {
      cartCount: cart.count(),
      signedIn: !!localStorage.getItem("jwt") && localStorage.getItem("jwt") !== "null",
    };
  },
  mounted() {
    this._onCart = () => (this.cartCount = cart.count());
    window.addEventListener(cart.EVENT, this._onCart);
  },
  beforeDestroy() {
    window.removeEventListener(cart.EVENT, this._onCart);
  },
};
</script>

<style scoped>
.mk-header {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  padding: 14px 0;
  color: #fff;
}
.mk-brand { display: flex; align-items: center; gap: 10px; color: #fff; font-size: 1.05rem; text-decoration: none; }
.mk-brand img { border-radius: 8px; background: #fff; }
.mk-link {
  color: #fff; padding: 6px 12px; border-radius: 8px; font-size: .88rem; text-decoration: none;
  display: inline-flex; align-items: center;
}
.mk-link:hover { background: rgba(255, 255, 255, .15); color: #fff; }
.mk-count {
  background: #f59e0b; color: #1e293b; border-radius: 10px; font-size: .72rem; font-weight: 700;
  padding: 1px 7px; margin-left: 6px;
}
.mk-sell {
  background: #fff; color: #1e3a5f; padding: 6px 14px; border-radius: 8px; font-weight: 600;
  font-size: .85rem; text-decoration: none;
}
.mk-sell:hover { opacity: .9; color: #1e3a5f; }
</style>
